import { render, staticRenderFns } from "./Area4.vue?vue&type=template&id=408565a2&scoped=true&"
import script from "./Area4.vue?vue&type=script&lang=js&"
export * from "./Area4.vue?vue&type=script&lang=js&"
import style0 from "./Area4.vue?vue&type=style&index=0&id=408565a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408565a2",
  null
  
)

export default component.exports